import React, { useEffect, useState } from 'react';
import {
  getMySupplierPublicInquiriesAction,
  getMyPublicSupplierProposalsAction,
  deleteMyPublicSupplierProposalAction
} from '../../../../../modules/myInquiries/Supplier/Public/Actions';
import api from '../../../../../helpers/api';
import {
  supplierPublicInquiriesSelector,
  supplierPublicInquiriesIsLoadingSelector,
  supplierPublicInquiriesCount,
  supplierProposalsSelector
} from '../../../../../modules/myInquiries/Supplier/Public/Selectors';
import { connect } from 'react-redux';

import List from '../../../../../components/Lists/List';
import ListItem from '../../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { supplierDataSelector } from '../../../../../modules/auth/Selectors';
import getLangData from '../../../../../utils/getLangData';

const MySupplierPublicInquiriesList = props => {
  const {
    publicInquiriesIsLoading,
    publicInquiriesCount,
    deleteSupplierProposal,
    supplierData
  } = props;

  const [publicInquiries, setpublicInquiries] = useState([])
  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const supplierId = supplierData?._id; // for testing only

  const getPublicInquiries = async body => {
   try {
    const {data}= await api.post(body.url, body);
    setpublicInquiries(data.content)
   } catch (error) {
     
   }
  };
  useEffect(() => {
    getPublicInquiries({
      filterSupplierID: supplierId,
      supplierId: supplierId,
      url: `public-supplier-staging-proposals/search-supplier-proposals`,
      filterBy: []
    });
  }, []);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (publicInquiries.length >= publicInquiriesCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getPublicInquiries({
      size,
      offset: publicInquiries.length,
      filterSupplierID: supplierId,
      supplierId: supplierId,
      url: `public-supplier-staging-proposals/search-supplier-proposals`,
      filterBy: []
    });
  };

  const dataLength =
    publicInquiries.length <= publicInquiriesCount
      ? publicInquiries.length
      : publicInquiriesCount;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={publicInquiriesIsLoading}
          header={{
            items: [getLangData().fields.name, getLangData().fields.title],
            actions: ['Edit', 'Delete']
          }}
          items={publicInquiries}
        >
          <table className='table'>
            <tbody>
              {publicInquiries.map(
                ({
                  title,
                  customerDetail,
                  message,
                  _id,
                  proposals,
                  customerProfileDetail,
                  customerData,
                  inquiry
                }) => {
                  const customer = customerDetail
                    ? customerDetail
                    : customerProfileDetail;
                  return (
                    <ListItem
                      type='multi'
                      name={inquiry.title}
                      data={[inquiry.customerBusinessName, inquiry.title]}
                      key={_id}
                      editLink={`/my-public-inquiries-supplier/my-pending-public-proposals/supplier/${_id}`}
                      // onDelete={() =>
                      //   deleteSupplierProposal({
                      //     inquiryId: _id,
                      //     supplierId: supplierId
                      //   })
                      // }
                    >
                      {console.log(publicInquiries)}
                    </ListItem>
                  );
                }
              )}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
  );
};

const mapStateToProps = state => ({
  publicInquiries: supplierProposalsSelector(state),
  publicInquiriesIsLoading: supplierPublicInquiriesIsLoadingSelector(state),
  publicInquiriesCount: supplierPublicInquiriesCount(state),
  supplierData: supplierDataSelector(state)
});

export default connect(mapStateToProps, {
  getPublicInquiries: getMyPublicSupplierProposalsAction,
  deleteSupplierProposal: deleteMyPublicSupplierProposalAction
})(MySupplierPublicInquiriesList);
